@if (isSubmitted) {
  <app-finished
    [minimumScore]="minimumScore"
    [userScore]="userScore"
    [totalScore]="totalScore"
    [isLastModule]="isLastModule"
    [isCourseComplete]="isCourseComplete"
    [isLoading]="isCompletingCourse"
    [passed]="activityPassed"
    [resultMessage]="resultMessage"
    (restart)="onRestart()"
    (nextModule)="nextModule.emit()"
    (certificate)="certificate.emit()"
    (completeCourse)="completeCourse.emit()"
  />
} @else if (isLoading) {
  <div>
    <l-spinner />
  </div>
} @else {
  <section class="relative flex h-full min-h-0 flex-col overflow-hidden text-lWhite">

    @if (currentQuestions.length > 0) {
      <article class="flex h-full min-h-0 flex-col px-3 py-4 sm:px-6 sm:py-5">
        <form [formGroup]="questionsForm" class="flex h-full min-h-0 flex-col">
          @for (question of currentQuestions; track $index) {
            <div class="flex h-full min-h-0 flex-col">
              <header class="flex items-start justify-between gap-4">
                <h1 class="text-2xl font-semibold leading-tight tracking-[-0.02em]">Questão {{ currentPage }}</h1>

                <div class="flex items-center gap-2">
                  <button
                    type="button"
                    class="grid h-10 w-10 place-items-center rounded-xl border border-lGray600 bg-lGray900 text-lg text-lWhite transition disabled:cursor-not-allowed disabled:opacity-40"
                    [disabled]="!canGoPrev() || isSubmitting"
                    (click)="prevPage()"
                    aria-label="Questão anterior"
                  >
                    <l-icon>chevron_left</l-icon>
                  </button>

                  <button
                    type="button"
                    class="grid h-10 w-10 place-items-center rounded-xl border border-lGray600 bg-lGray900 text-lg text-lWhite transition disabled:cursor-not-allowed disabled:opacity-40"
                    [disabled]="isSubmitting || currentPage === totalPages"
                    (click)="onForwardClick()"
                    [attr.aria-label]="currentPage === totalPages ? 'Enviar respostas' : 'Próxima questão'"
                  >
                    <l-icon>chevron_right</l-icon>
                  </button>
                </div>
              </header>

              <p class="mt-8 max-w-none text-xl text-lWhite">
                {{ question.question }}
              </p>

              <div class="mt-10 flex-1 space-y-3 overflow-y-auto pr-1">
                @for (option of question.options; track $index) {
                  <label (click)="selectOption(question.id, $index)" class="group flex cursor-pointer items-center gap-3 rounded-lg px-3 py-3 transition hover:bg-lWhite/5">
                    <input type="radio" class="sr-only" [formControlName]="question.id" [value]="$index">

                    <span class="grid h-5 w-5 place-items-center rounded-full border" [ngClass]="isOptionSelected(question.id, $index) ? 'border-lPrimary bg-lPrimary' : 'border-lGray700'">
                      @if (isOptionSelected(question.id, $index)) {
                        <l-icon class="!text-lg -translate-y-[5px] text-white">check</l-icon>
                      }
                    </span>

                    <span class="text-base leading-7 text-lWhite">{{ option.text }}</span>
                  </label>
                }
                
              </div>
            </div>
          }
          
          @if (currentPage === totalPages) {
            <div class="mt-4 flex justify-center">
              <button
                lButton
                type="button"
                [bType]="buttonTypeEnum.PRIMARY"
                [bRadius]="buttonRadiusEnum.LARGE"
                [disabled]="!questionsForm.valid || isSubmitting"
                (click)="submitAnswers()"
                class="!w-44"
              >
                @if (isSubmitting) {
                  <l-spinner [size]="'small'" />
                }
                Enviar avaliação
              </button>
            </div>
          }
        </form>

        
      </article>

      <footer class="mt-4 flex items-center justify-end gap-4 text-lSecondary mr-3">
        <p class="text-base"> {{ currentPage }} / {{ totalPages }} </p>

        <div class="flex items-center gap-2.5">
          @for (question of activity.questions; track $index) {
            <span class="h-4 w-4 rounded-full" [ngClass]="($index + 1 === currentPage) || isQuestionAnswered(question.id) ? 'bg-lPrimary' : 'bg-lGray700'"></span>
          }
          
        </div>
      </footer>
    } @else {
      <article class="grid flex-1 place-items-center px-6 text-center">
        <p class="text-sm text-lWhite/70">Nenhuma questão disponível.</p>
      </article>
    }
    
  </section>
}
